import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import SearchIcon from "@mui/icons-material/Search";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  Box,
  Button,
  Chip,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import React, { useEffect, useState } from "react";
import KenLoader from "../../GlobalComponents/KenLoader";
import { getPlayersDetails, getTeamDetails } from "../../Utils/apiService";
import {
  extractStatByRole,
  formatToIndianCurrencyWords2,
  mapHighestLevelToCategory,
} from "../../Utils/helperFunctions";
import { useAuthStore } from "../../store";
import routes from "../../Utils/routes";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../Components/Layout/AdminLayout";
import { mcaLogo } from "../../Assets";
import { KITTY_ALLOCATION } from "../Dashboard";

const commonCellStyles = {
  color: "#fff",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  border: "none",
};

const TeamsDashboard = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");
  const [playerDetails, setplayerDetails] = useState<any>(null);
  const [TeamDetails, setTeamDetails] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  } | null>(null);
  const [roleFilter, setRoleFilter] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);
  const [teamFilter, setTeamFilter] = useState<string | null>(null);
  const [appliedFilters, setAppliedFilters] = useState<{
    role?: string;
    status?: string;
    category?: string;
    team?: string;
  }>({});
  const [filterMenu, setFilterMenu] = useState(false);
  const [myTeamData, setMyTeamData] = useState<any>(null);
  const [balanceKittyAmount, setbalanceKittyAmount] = useState<any>();
  console.log(JSON.stringify(myTeamData), "myTeamData");

  const teamId = localStorage.getItem("teamId");

  const { teamDetailsTrigger } = useAuthStore();

  const fetchData = async () => {
    try {
      const [playersRes, teamsDetail] = await Promise.all([
        getPlayersDetails(),
        getTeamDetails(),
      ]);

      if (playersRes?.data?.success) {
        setplayerDetails(playersRes.data.data);
      }
      if (teamsDetail?.data?.success) {
        const allTeams = teamsDetail.data.data;
        const currentTeam = allTeams.find((team: any) => team.Id === teamId);

        let totalkittyamt: any = 0;
        for (
          let i = 0;
          i < currentTeam?.Player_Registrations__r?.records?.length;
          i++
        ) {
          let p = currentTeam?.Player_Registrations__r?.records[i];
          console.log(p, "p");
          totalkittyamt = totalkittyamt + (p.Kitty_Bid_Amount__c || 0);
        }
        let balanceKitty = KITTY_ALLOCATION - totalkittyamt;
        setbalanceKittyAmount(balanceKitty);
        console.log(balanceKitty, "balanceKitty");

        console.log(JSON.stringify(currentTeam), "currentTeam");
        setMyTeamData(currentTeam);
        setTeamDetails(allTeams);
        if (currentTeam?.Name) {
          setAppliedFilters((prev) => ({
            ...prev,
            team: currentTeam.Name,
          }));
        }
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [teamDetailsTrigger]);

  const handleFilterMenuToggle = () => {
    setFilterMenu((prev) => !prev);
  };

  const filteredPlayers = playerDetails?.filter(
    (player: any, index: number) => {
      // if (player.soldToId !== teamId) {
      //   return false;
      // }
      const term = searchTerm?.toLowerCase();

      // Fallback to normal text-based search
      const matchesSearch =
        player?.name?.toLowerCase().includes(term) ||
        // player.MCANo?.toLowerCase().includes(term) ||
        player?.auctionNumber?.toString() === term;
      // mapHighestLevelToCategory(player.recentCompetetionLevel)
      //   ?.toLowerCase()
      //   .includes(term);

      const matchesRole =
        !appliedFilters.role || player.role === appliedFilters.role;
      const matchesStatus =
        !appliedFilters.status ||
        (appliedFilters.status === "Sold" && player.auctionResult === "Sold") ||
        (appliedFilters.status === "Unsold" &&
          player.auctionResult === "Unsold") ||
        (appliedFilters.status === "Pending" && !player.auctionResult);

      const matchesCategory =
        !appliedFilters.category ||
        mapHighestLevelToCategory(player.recentCompetetionLevel) ===
          appliedFilters.category;

      const teamFilters =
        !appliedFilters.team || player.soldTo === appliedFilters.team;

      return (
        matchesSearch &&
        matchesRole &&
        matchesStatus &&
        matchesCategory &&
        teamFilters
      );
    }
  );

  const sortedPlayers = React.useMemo(() => {
    if (!sortConfig) return filteredPlayers;
    const sorted = [...filteredPlayers].sort((a, b) => {
      const valA = a[sortConfig.key]?.toLowerCase?.() || "";
      const valB = b[sortConfig.key]?.toLowerCase?.() || "";
      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [filteredPlayers, sortConfig]);

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
    navigate(routes.login);
  };

  const remainingFundFormatted = formatToIndianCurrencyWords2(
    myTeamData?.Fund_Remaining__c
  );

  const getCategoryCount = (level: string) =>
    sortedPlayers.filter(
      (p: any) => p?.recentCompetetionLevel === level && p?.soldToId === teamId
    ).length;

  const totalPlayers = sortedPlayers?.filter(
    (p: any) => p?.soldToId === teamId
  ).length;

  if (!playerDetails || !TeamDetails) {
    return <KenLoader />;
  }

  return (
    <Box className={classes.desktopLayout}>
      <Box className={classes.desktopHeader}>
        <Box className={classes.desktopHeaderContainer}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <img
              src={mcaLogo}
              style={{ height: "50px", width: "auto" }}
              alt="logo"
            />
            {myTeamData?.Logo_URL__c && (
              <img
                src={myTeamData?.Logo_URL__c}
                alt="bg"
                height={100}
                width={100}
                style={{ width: "6vw", height: "6vw" }}
              />
            )}
            <Box
              sx={{
                padding: "10px 40px 10px 20px",
                display: "flex",
                borderRadius: "0 12px 12px 0",
                color: "#ffffff80",
                gap: "1vw",
              }}
            >
              {[
                {
                  label: "Icon players",
                  value: `${getCategoryCount("Indian senior team")}/1`,
                },
                {
                  label: "Senior players",
                  value: `${getCategoryCount(
                    "First class, list A, BCCI Senior Men T20"
                  )}/4`,
                },
                {
                  label: "Emerging players",
                  value: `${getCategoryCount(
                    "Mumbai age group team (under 23 or under 19)"
                  )}/5`,
                },
                {
                  label: "Development players",
                  value: `${getCategoryCount("Local club team")}/5`,
                },
                {
                  label: "Total players",
                  value: `${totalPlayers}/18`,
                },
              ].map((item, idx) => (
                <Box
                  key={idx}
                  sx={{
                    p: "10px 10px",
                    background: "rgba(255, 255, 255, 0.10)",
                  }}
                >
                  <Typography variant="h2" sx={{ fontSize: 44, color: "#fff" }}>
                    {item.value}
                  </Typography>
                  <Typography variant="h2" sx={{ fontSize: 12 }}>
                    {item.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Box
              sx={{
                padding: "10px 40px 10px 20px",
                display: "flex",
                gap: "1vw",
                borderRadius: "0 12px 12px 0",
                color: "#ffffff80",
              }}
            >
              {[
                {
                  label: "Team purse",
                  value: "₹1CR",
                },
                {
                  label: "Fund remaining",
                  value: remainingFundFormatted,
                },
                {
                  label: "Funds remaining for bidding",
                  value: formatToIndianCurrencyWords2(balanceKittyAmount),
                },
              ].map((item, idx) => (
                <Box
                  key={idx}
                  sx={{
                    p: "16px 16px",
                    background: "rgba(255, 255, 255, 0.10)",
                  }}
                >
                  <Typography variant="h2" sx={{ fontSize: "32px", color: "#fff" }}>
                    {item.value}
                  </Typography>
                  <Typography variant="h2" sx={{ fontSize: "14px" }}>
                    {item.label}
                  </Typography>
                </Box>
              ))}
            </Box>
            <Box
              sx={{
                color: "black",
                fontSize: "16px",
                fontWeight: 500,
                padding: "13px 32px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "0.5px solid #696969",
                borderRadius: "8px",
                backgroundColor: "#fff",

                textAlign: "center",
              }}
              onClick={handleLogout}
            >
              Logout
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className={classes.desktopContainer} style={{}}>
        <Box className={classes.desktopScreen}>
          <Box bgcolor="" color="#fff">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "36px",
              }}
            >
              <Box sx={{ display: "flex", gap: "20px" }}>
                <Typography variant="h4">
                  Player list t20 Mumbai - 2025
                </Typography>
                <Box display="flex" gap={1} flexWrap="wrap">
                  {appliedFilters.role && (
                    <Chip
                      label={appliedFilters.role}
                      onDelete={() =>
                        setAppliedFilters((prev) => ({
                          ...prev,
                          role: undefined,
                        }))
                      }
                      deleteIcon={<CloseOutlinedIcon />}
                      sx={{
                        backgroundColor: "#333",
                        color: "#fff",
                        border: "1px solid #8D8D8D",
                        "& .MuiChip-deleteIcon": {
                          marginLeft: "4px",
                          color: "#fff",
                        },
                        "&:hover": {
                          backgroundColor: "#2a2a2a",
                        },
                      }}
                    />
                  )}
                  {appliedFilters.status && (
                    <Chip
                      label={appliedFilters.status}
                      onDelete={() =>
                        setAppliedFilters((prev) => ({
                          ...prev,
                          status: undefined,
                        }))
                      }
                      deleteIcon={<CloseOutlinedIcon />}
                      sx={{
                        backgroundColor: "#333",
                        color: "#fff",
                        border: "1px solid #8D8D8D",
                        "& .MuiChip-deleteIcon": {
                          marginLeft: "4px",
                          color: "#fff",
                        },
                        "&:hover": {
                          backgroundColor: "#2a2a2a",
                        },
                      }}
                    />
                  )}
                  {appliedFilters.category && (
                    <Chip
                      label={appliedFilters.category}
                      onDelete={() =>
                        setAppliedFilters((prev) => ({
                          ...prev,
                          category: undefined,
                        }))
                      }
                      deleteIcon={<CloseOutlinedIcon />}
                      sx={{
                        backgroundColor: "#333",
                        color: "#fff",
                        border: "1px solid #8D8D8D",
                        "& .MuiChip-deleteIcon": {
                          marginLeft: "4px",
                          color: "#fff",
                        },
                        "&:hover": {
                          backgroundColor: "#2a2a2a",
                        },
                      }}
                    />
                  )}
                  {appliedFilters.team && (
                    <Chip
                      label={appliedFilters.team}
                      onDelete={() =>
                        setAppliedFilters((prev) => ({
                          ...prev,
                          team: undefined,
                        }))
                      }
                      deleteIcon={<CloseOutlinedIcon />}
                      sx={{
                        backgroundColor: "#333",
                        color: "#fff",
                        border: "1px solid #8D8D8D",
                        "& .MuiChip-deleteIcon": {
                          marginLeft: "4px",
                          color: "#fff",
                        },
                        "&:hover": {
                          backgroundColor: "#2a2a2a",
                        },
                      }}
                    />
                  )}
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
                <Box sx={{ position: "relative" }}>
                  <Box
                    sx={{
                      border: "0.5px solid rgba(255, 255, 255, 0.20)",
                      borderRadius: "12px 8px 8px 8px",
                      background: " #161616",
                      padding: "15px",
                      display: "flex",
                      gap: "4px",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onClick={handleFilterMenuToggle}
                  >
                    Filter <FilterAltOutlinedIcon fontSize="small" />
                  </Box>
                  {filterMenu && (
                    <ClickAwayListener onClickAway={() => setFilterMenu(false)}>
                      <Box
                        sx={{
                          background: "#111",
                          borderRadius: "12px",
                          padding: "20px",
                          width: 300,
                          zIndex: 10,
                          minHeight: "400px",
                          position: "absolute",
                          top: "60px",
                          right: "0",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.4)",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography variant="h6" color="#fff" mb={2}>
                          Filters
                        </Typography>
                        <TextField
                          select
                          fullWidth
                          value={roleFilter || ""}
                          onChange={(e) => setRoleFilter(e.target.value)}
                          SelectProps={{ native: true }}
                          sx={{ mb: 2 }}
                        >
                          <option value="">Select role</option>
                          <option value="Batsman">Batsman</option>
                          <option value="Bowler">Bowler</option>
                          <option value="All - rounder">All - rounder</option>
                        </TextField>
                        <TextField
                          select
                          fullWidth
                          value={statusFilter || ""}
                          onChange={(e) => setStatusFilter(e.target.value)}
                          SelectProps={{ native: true }}
                          sx={{
                            mb: 2,
                            "& .MuiSelect-icon": {
                              color: "#fff",
                            },
                          }}
                        >
                          <option value="">Select status</option>
                          <option value="Sold">Sold</option>
                          <option value="Unsold">Unsold</option>
                          <option value="Pending">Pending</option>
                        </TextField>
                        <TextField
                          select
                          fullWidth
                          value={categoryFilter || ""}
                          onChange={(e) => setCategoryFilter(e.target.value)}
                          SelectProps={{ native: true }}
                          sx={{
                            mb: 2,
                            "& .MuiSelect-icon": {
                              color: "#fff",
                            },
                          }}
                        >
                          <option value="">Select Category</option>
                          <option value="Icon Player">Icon Player</option>
                          <option value="Senior Player">Senior Player</option>
                          <option value="Emerging Player">
                            Emerging Player
                          </option>
                          <option value="Development Player">
                            Development Player
                          </option>
                        </TextField>
                        <TextField
                          select
                          fullWidth
                          value={teamFilter || ""}
                          onChange={(e) => setTeamFilter(e.target.value)}
                          SelectProps={{ native: true }}
                          sx={{ mb: 2 }}
                        >
                          <option value="">Select Team</option>
                          {TeamDetails?.map((team: any) => (
                            <option key={team.Id} value={team.Name}>
                              {team.Name}
                            </option>
                          ))}
                        </TextField>

                        <Box display="flex" gap={2} mt={"auto"}>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              setRoleFilter(null);
                              setStatusFilter(null);
                              setCategoryFilter(null);
                              setTeamFilter(null);
                              setAppliedFilters({});
                            }}
                            sx={{ color: "#fff", borderColor: "#fff", flex: 1 }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="contained"
                            onClick={() => {
                              setAppliedFilters({
                                ...(roleFilter && { role: roleFilter }),
                                ...(categoryFilter && {
                                  category: categoryFilter,
                                }),
                                ...(statusFilter && { status: statusFilter }),
                                ...(teamFilter && { team: teamFilter }),
                              });
                              setFilterMenu(false);
                            }}
                            sx={{
                              bgcolor: "#fff",
                              color: "#000",
                              fontWeight: 600,
                              flex: 1,
                            }}
                          >
                            {/* {filteredPlayers.length} */}
                            Show results
                          </Button>
                        </Box>
                      </Box>
                    </ClickAwayListener>
                  )}
                </Box>
                <TextField
                  // label="Search"
                  placeholder="Search"
                  variant="outlined"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon
                          style={{ color: "#94969C", fontSize: "20px" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    borderRadius: "12px",
                    fontSize: "10px!important",
                    fontWeight: "350!important",
                    marginBottom: "0",
                    width: "320px",

                    color: "white",
                    // border: "1px solid #222",
                    "& .MuiOutlinedInput-root": {
                      "&:hover fieldset": {
                        borderColor: "#fff",
                        color: "#fff",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#7F56D9",
                      },
                      "& input": {
                        color: "#fff",
                      },
                    },
                  }}
                />
              </Box>
            </Box>

            <TableContainer
              component={Paper}
              sx={{ backgroundColor: "#1e1e1e", border: "1px solid #FFFFFF33" }}
            >
              <Table>
                <TableHead>
                  <TableRow sx={{ borderBottom: "1px solid #FFFFFF33" }}>
                    {[
                      { label: "Auction No" },
                      { label: "Name of the player", sortKey: "name" },
                      { label: "Role" },
                      // { label: "Runs" },
                      // { label: "Matches" },
                      // { label: "Wickets" },
                      { label: "Base price" },
                      { label: "Category" },
                      { label: "Sold for" },
                      { label: "Status" },
                      { label: "Sold to" },
                    ].map(({ label, sortKey }, idx) => {
                      const isActive = sortKey && sortConfig?.key === sortKey;
                      const isSortable = Boolean(sortKey);
                      const direction = isActive
                        ? sortConfig?.direction
                        : "asc";
                      return (
                        <TableCell
                          key={idx}
                          sx={{
                            color: "#fff",
                            border: "none",
                            fontWeight: "600",
                            fontSize: "16px",
                            cursor: isSortable ? "pointer" : "default",
                            userSelect: "none",
                          }}
                          onClick={() => {
                            if (!sortKey) return;
                            setSortConfig((prev) =>
                              prev?.key === sortKey
                                ? {
                                    key: sortKey,
                                    direction:
                                      prev.direction === "asc" ? "desc" : "asc",
                                  }
                                : { key: sortKey, direction: "asc" }
                            );
                          }}
                        >
                          <Box display="flex" alignItems="center" gap="4px">
                            {label}
                            {isSortable && (
                              <span
                                style={{
                                  fontSize: "14px",
                                  opacity: isActive ? 1 : 0.5,
                                }}
                              >
                                {direction === "asc" ? (
                                  <SwapVertIcon />
                                ) : (
                                  <SwapVertIcon />
                                )}
                              </span>
                            )}
                          </Box>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedPlayers
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((player: any, index: number) => {
                      const soldStatus =
                        player.auctionResult === "Sold"
                          ? {
                              label: "Sold",
                              background: "#7DC789",
                              color: "##212120",
                            }
                          : player.auctionResult === "Unsold"
                          ? {
                              label: "Unsold",
                              background: "#F8A6A6",
                              color: "#212120",
                            }
                          : null;

                      const { runs, matches, wickets } =
                        extractStatByRole(player);

                      return (
                        <TableRow
                          key={player.playerId}
                          sx={{ borderBottom: "1px solid #FFFFFF33" }}
                        >
                          <TableCell sx={commonCellStyles}>
                            {player?.auctionNumber ?? "--"}
                          </TableCell>
                          <TableCell sx={commonCellStyles}>
                            {player.name}
                          </TableCell>
                          <TableCell sx={commonCellStyles}>
                            {player.role}
                          </TableCell>

                          <TableCell sx={commonCellStyles}>
                            {player.basePrice != null
                              ? `₹${player.basePrice.toLocaleString("en-IN")}`
                              : "--"}
                          </TableCell>
                          <TableCell sx={commonCellStyles}>
                            {mapHighestLevelToCategory(
                              player?.recentCompetetionLevel
                            )}
                          </TableCell>

                          <TableCell sx={commonCellStyles}>
                            {player.winningBid != null
                              ? `₹${player.winningBid.toLocaleString("en-IN")}`
                              : "--"}
                          </TableCell>
                          <TableCell sx={commonCellStyles}>
                            {soldStatus ? (
                              <Chip
                                label={soldStatus.label}
                                sx={{
                                  color: soldStatus.color,
                                  background: soldStatus.background,
                                  borderRadius: "8px",
                                  height: "36px",
                                  minWidth: "83px",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              />
                            ) : (
                              "--"
                            )}
                          </TableCell>
                          <TableCell sx={commonCellStyles}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <Box
                                component={"img"}
                                sx={{ height: "25px" }}
                                src={
                                  player?.soldToLogo ? player?.soldToLogo : ""
                                }
                                alt=""
                              />
                              {player?.soldTo || "--"}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={filteredPlayers?.length}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              sx={{
                color: "#fff",
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                  {
                    color: "#fff",
                  },
                "& .MuiInputBase-root": {
                  color: "#fff",
                },
                "& .MuiSvgIcon-root": {
                  fill: "#fff",
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TeamsDashboard;
